import { NoDrillabilityReason } from '@upright/common/model/output/scores/sdg-alignment/api-types';
import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import styled from 'styled-components';
import { WarningAlert } from '../../../../../../generic/components/alerts/warning-alert';

interface Props {
  reason: NoDrillabilityReason;
}

function getExplanation(reason: NoDrillabilityReason) {
  switch (reason) {
    case NoDrillabilityReason.SDG8:
      return <>Detailed drilldowns are currently not available for SDG 8.</>;
    case NoDrillabilityReason.COVERAGE_CLASS_EXTENDED:
      return (
        <>
          An SDG drilldown for this company is not available because this company is part of Upright's <b>extended</b>{' '}
          coverage. SDG drilldowns are only available for companies that belong to Upright's <b>standard</b> coverage.
        </>
      );
    case NoDrillabilityReason.NO_DATA:
    case NoDrillabilityReason.SINGLE_ALIGNED_PRODUCT:
    case NoDrillabilityReason.SINGLE_MODERATELY_ALIGNED_PRODUCT:
    case NoDrillabilityReason.SINGLE_STRONG_ALIGNED_PRODUCT:
    default:
      return <>This SDG drilldown is currently not available.</>;
  }
}

export const SdgModalEmptyState = (props: Props) => {
  return (
    <Root>
      <WarningAlert>{getExplanation(props.reason)}</WarningAlert>
    </Root>
  );
};

const Root = styled.div`
  padding: 1em;
  ${getTextStyle({ size: 'xxs' })}
`;
